'use client';

import React, { createContext, useContext } from 'react';
import { densityConfig, type Density, type DensityValues } from '../tokens/density';

const DensityContext = createContext<DensityValues>(densityConfig.comfortable);

export function DensityProvider({
  density = 'compact',
  children,
}: {
  density?: Density;
  children: React.ReactNode;
}) {
  return (
    <DensityContext.Provider value={densityConfig[density]}>{children}</DensityContext.Provider>
  );
}

export function useDensity(): DensityValues {
  return useContext(DensityContext);
}
